<template>
  <Modal v-model="createLinkModal" width="600" :transfer="false" :mask-closable="false"
    :title="$t('key1003128')" @on-visible-change="createLinkChange">
    <Form :model="createLinkForm" ref="createLinkForm" :rules="ruleValidate" :label-width="90" @submit.native.prevent>
      <Row style="width: 98%">
        <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
          <Form-item :label="$t('key1003117')" prop="linkName">
            <Input v-model.trim="createLinkForm.linkName" :placeholder="$t('key1000324')"></Input>
          </Form-item>
        </Col>
        <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
          <Form-item :label="$t('key1003119')" prop="labelType_0">
            <Select v-model="createLinkForm.labelType_0" transfer filterable>
              <Option v-for="item in createdBysList" :key="item.userId" :value="item.userId">{{ item.userName }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
          <Form-item :label="$t('key1003118')" prop="labelType_1">
            <Input v-model.trim="createLinkForm.labelType_1" :placeholder="$t('key1000324')"></Input>
          </Form-item>
        </Col>
        <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
          <Form-item :label="$t('key1003120')" prop="labelType_2">
            <Input v-model.trim="createLinkForm.labelType_2" :placeholder="$t('key1000324')"></Input>
          </Form-item>
        </Col>
        <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
          <Form-item :label="$t('key1003121')" prop="labelType_3">
            <Input v-model.trim="createLinkForm.labelType_3" :placeholder="$t('key1000324')"></Input>
          </Form-item>
        </Col>
        <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
          <Form-item :label="$t('key1003122')" prop="labelType_4">
            <Input v-model.trim="createLinkForm.labelType_4" :placeholder="$t('key1000324')"></Input>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1000001')" prop="linkAddress">
            <Input v-model.trim="createLinkForm.linkAddress"></Input>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1001495')" prop="remark">
            <Input v-model.trim="createLinkForm.remark" type="textarea" :autosize="{ minRows: 4, maxRows: 10}"></Input>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="createLinkModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="createLinkBtn">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";

export default {
  name: "createLinkModal",
  mixins: [Mixin],
  props: {
    createdBysList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    let v = this;
    return {
      createLinkModal: false,
      createLinkForm: {
        isSelfDeveloped: 0,
        linkAddress: '', // 链接地址
        linkName: '', // 链接名称
        remark: '', // 备注
        resourceFlow: 0,
        source: 'YMS',
        labelType_0: '', // 推广人
        labelType_1: '', // 来源渠道
        labelType_2: '', // 推广方式
        labelType_3: '', // 推广内容
        labelType_4: '', // 推广组
      },
      ruleValidate: {
        linkName: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003112'), trigger: 'blur'},
        ],
        linkAddress: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003126'), trigger: 'blur'},
          {pattern: v.$regular.linkAddress, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001296'), trigger: 'blur',},
        ],
      }
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    }
  },
  methods: {
    // 保存
    createLinkBtn() {
      let v = this;
      let query = {
        tokenLabelBoList: []
      };
      for (let key in v.createLinkForm) {
        if (key.includes('labelType_')) {
          let labelType = key.split('labelType_')[1];
          if (v.createLinkForm[key]) {
            query.tokenLabelBoList.push({
              labelType: Number(labelType),
              labelValue: v.createLinkForm[key]
            });
          }
        } else {
          query[key] = v.createLinkForm[key];
        }
      }
      v.$refs['createLinkForm'].validate((valid) => {
        if (valid) {
          v.axios.post(api.post_ymsToker, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003127'));
              v.createLinkModal = false;
              v.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 监听弹窗
    createLinkChange(value) {
      if (!value) {
        this.$refs['createLinkForm'].resetFields();
      } else {
        if (this.createdBysList.length > 0) {
          let arr = this.createdBysList.filter((item) => {
            return item.userId === this.userInfo.userId;
          });
          this.createLinkForm.labelType_0 = arr[0].userId;
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>

</style>